import store from "../../../../store";
import { has, have } from "../../../../utils/menu-context";

export const createConditionAction = () => {
    return {
        canEdit: ({ props, record }) => {
            let result = false;
            const { menuContext } = props;
            const roleEdit = store.state.resource.auth.info?.roles.map((d) => d.refRole?.name).find((d) => d === "EDIT_LICENSE_STATUS");
            if (!has({ menuContext, key: "canEdit" }) || record.isActive === false) return false;
            if (
                has({ menuContext, key: "canEdit" }) &&
                have({ menuContext, key: record.refStatus?.attribute['canActionAttribute'] })
            ) {
                result = true || result;
            }
            if (["EDIT_LICENSE_STATUS"].includes(roleEdit)) {
                result = true || result;
            }
            return result;
        }
    };
};

export const createConditionForm = () => {
    return [];
};
